import createVueApp from '@/common/createApp'

Styxie.Initializers.MobileInvitations = {
  edit: async(props) => {
    const { default: InvitationsEdit } = await import('@/vue_widgets/mobile/invitations/edit/index.vue')
    createVueApp(InvitationsEdit, { props, layout: null })
  }
}
